import { styled } from 'styled-components';

import { colors, shadows } from '#/theme/theme';

export const StyledArrowButton = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.brandBlue};
  border-radius: 100%;
  transition: 0.3s all ease;

  &:not(:disabled) {
    pointer-events: all;
  }

  &:disabled {
    opacity: 0.5;
  }

  &:hover {
    box-shadow: ${shadows.low};
  }
`;
